export const REFERRAL_SETTINGS_LIST = "REFERRAL_SETTINGS_LIST";
export const REFERRAL_SETTINGS_EDIT = "REFERRAL_SETTINGS_EDIT";
export const REFERRAL_SETTINGS_UPDATE = "REFERRAL_SETTINGS_UPDATE";

